import { StoreOptions } from 'vuex';
import { IRootState } from '@/store/rootstate';
import modules from './modules';
import { search } from '@/util/location';

import plugins from './plugins';

import { IUserInit } from '@/store/modules/user/helper';

import api from '@/api/signup';
import router from '@/router';
import { logger } from '@/util/logger';

export default {
  strict: process.env.NODE_ENV !== 'production',
  modules,
  plugins,

  state: {
    token: '',
  },

  getters: {
    token: (s) => s.token,
  },

  actions: {
      async init({ dispatch, rootGetters }) {
      return await dispatch('authorise', search)
        .then(() => dispatch('signup/init'))
        // .then(() => {
        //   if (rootGetters['signup/strategy']) {
        //     logger.log('found stored strategy - tracking the request')
        //     // return dispatch('trackRequest');
        //   }
        // })
        .then(() =>
          Promise.all([
            // dispatch('settings/init'),
            // dispatch('signup/init'),
            dispatch('navigation/init'),
          ]),
        );
    },

    async authorise({ commit, dispatch, state }, query) {
      const { token, ...rest } = query;
      commit('updateToken', token || state.token);
      const response = await api.authorise({ ...rest, create: true });

      if (!response.allowSignup) {
        throw new Error(
          `Sorry we are unable to offer our services at this time. Please contact ${
            response.client
          }`,
        );
      }

      if (response.expiredLink) {
        throw new Error(
          `Sorry we are unable to process this request as the application link has now expired.  If you have not already completed the 
           application process or believe that you are seeing this message in error then please contact ${
            response.client
          }.`,
        );
      }

      const payload: IUserInit = {
        static: rest,
        externalReference: null,
        acceptedPrivacy: false,
        acceptedTerms: false,
      };
      if (response.bank) {
        payload.bank = response.bank.item;
        payload.bankSearch = response.bank.search;
      }

      payload.acceptedPrivacy = response.acceptedPrivacy;
      payload.acceptedTerms = response.acceptedTerms;
      payload.externalReference = response.externalReference;
      payload.referenceGuid = response.referenceGuid;
      
      dispatch('user/init', payload);

      const newQuery = {
        ...query,
        token: response.newToken,
      };

      logger.verbose('replacing query', { query, newQuery });
      // sync the current state;
      dispatch('updateToken', response.newToken);
      await dispatch('settings/init');
      const route = router.currentRoute;
      router.replace({
        name: route.name,
        query: newQuery,
      });

      return true;
    },
    updateToken({ commit }, token) {
      commit('updateToken', token);
    },
  },
  mutations: {
    updateToken(state, token) {
      state.token = token;
    },
  },
} as StoreOptions<IRootState>;
